import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { useEffect } from "react";

export function LegalPage({ title, updated, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#FFFFFF] min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0A192F] transition-colors" data-testid="legal-back">
          <ArrowLeft size={16} /> Back to home
        </Link>
        <span className="label block mt-10">Legal</span>
        <h1 className="font-display text-5xl tracking-tight mt-4 text-[#0A192F]">{title}</h1>
        <p className="font-mono text-xs text-[#64748B] mt-3">Last updated: {updated}</p>
        <div className="prose-legal mt-10 space-y-6 text-[#475569] leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

function H({ children }) { return <h2 className="font-display text-2xl text-[#0A192F] mt-10 mb-2">{children}</h2>; }

export function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="June 2026">
      <p>This Privacy Policy explains how information submitted through this website is handled. This is a general template and should be reviewed by Catalyst Solutions and the clinic before publication.</p>
      <H>Information We Collect</H>
      <p>When you submit an appointment or contact enquiry, we collect the details you provide, such as your name, phone number, email and message. This information is used solely to respond to your enquiry.</p>
      <H>How Information Is Used</H>
      <p>Submitted information is used to review and respond to consultation requests and enquiries. It is not sold or shared for marketing purposes.</p>
      <H>Data Storage</H>
      <p>Enquiries are stored securely and accessible only to authorised clinic administrators. [Retention period and specific data handling policies to be confirmed by the clinic.]</p>
      <H>Your Choices</H>
      <p>You may request that your submitted information be updated or removed by contacting the clinic directly.</p>
      <H>Contact</H>
      <p>For privacy-related questions, please contact the clinic using the details provided on the homepage.</p>
    </LegalPage>
  );
}

export function MedicalDisclaimer() {
  return (
    <LegalPage title="Medical Disclaimer" updated="June 2026">
      <p>The information provided on this website is for general informational and educational purposes only and is not intended as, and should not be relied upon as, medical advice.</p>
      <H>Not a Substitute for Professional Advice</H>
      <p>Content on this website does not constitute personalised medical advice, diagnosis or treatment. Always seek the advice of a qualified healthcare professional with any questions you may have regarding a medical condition.</p>
      <H>No Doctor–Patient Relationship</H>
      <p>Using this website or submitting an enquiry does not create a doctor–patient relationship. Such a relationship is established only through a confirmed, direct consultation.</p>
      <H>Appointment Enquiries</H>
      <p>Submitting the appointment form sends an enquiry to the clinic. It does not guarantee or confirm a booking. The clinic will provide appointment guidance.</p>
      <H>Emergencies</H>
      <p>This website is not intended for medical emergencies. In an emergency, contact your local emergency services immediately.</p>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Use" updated="June 2026">
      <p>By using this website you agree to the following general terms. This is a template to be reviewed before publication.</p>
      <H>Use of Content</H>
      <p>Content is provided for general information. It may be updated or changed at any time without notice.</p>
      <H>Accuracy</H>
      <p>While care is taken to keep information accurate, no warranty is given regarding completeness or accuracy. Professional details are maintained by the clinic and Catalyst Solutions.</p>
      <H>External Links</H>
      <p>This website may link to external services such as maps or messaging platforms. We are not responsible for the content of external sites.</p>
    </LegalPage>
  );
}
